import styled from 'styled-components';

export const Wrapper = styled.div`
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
    font-size: 14px;
    margin-right: 16px;
    border-radius: 4px;
    transition: background-color 250ms;

    &:hover {
        background-color: rgba(25, 118, 210, 0.04);
    }
`;

export const StyledInput = styled.label`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 109px;
    height: 36px;

    & input {
        display: none;
    }

    & svg {
        margin-right: 8px;
    }

    & svg path {
        fill: #0781d7;
        fill-opacity: 1;
    }
`;
